import { inject, computed, getCurrentInstance, onMounted, watch } from 'vue';
import { useStoreCore } from '@/hooks';
import { useHistoryNav } from '@rebuild/hooks/comp/useHistoryNav';
import { useBannerImage } from '@rebuild/hooks/comp/useBannerImage';
import { useStore } from '@/utils/vue-api';

export function useFlowLayoutCore() {
	const templateMenus = inject('TEMPLATE_MENUS');
	const getDisplayMenus = computed(() => templateMenus?.value || []);

	const vm = getCurrentInstance();
	const inHomeView = computed(() => vm.proxy.$route.name.includes('home'));

	// ===================== Banner =====================
	const { bannerRef, initBannerImage } = useBannerImage();
	onMounted(() => {
		initBannerImage();
	});

	const { shouldShowUI } = useStoreCore();
	const showHeaderNav = computed(() => shouldShowUI('menuBar'));

	// ===================== 首页导航 =====================
	const filterMenus = computed(() => {
		const menus = getDisplayMenus.value;
		return menus
			.filter(menu => menu.moduleVOS?.length && menu.name)
			.map(item => ({
				name: item.name,
				id: item.id,
				moduleVOS: item.moduleVOS
			}));
	});

	// ===================== 历史导航 =====================
	const { getNavigationList, initNavigation, updateNavigation } = useHistoryNav();
	initNavigation(vm.proxy.$route);
	watch(
		() => vm.proxy.$route,
		newRoute => {
			updateNavigation(newRoute);
		}
	);

	// ===================== 强刷导航菜单 UI =====================
	const store = useStore();
	const getCommonData = computed(() => store.getters.getCommonData);
	const getCommonDataKey = computed(() => getCommonData.value?._key || 'flow_nav_bar');

	return {
		banner: bannerRef,
		showHeaderNav,
		filterMenus,
		inHomeView,
		getNavigationList,
		getCommonDataKey
	};
}
